import { SET_FAVORITE_PLANT, GET_FAVORITE_PLANTS, RESET_USER } from '../actions'

const INITIAL_STATE = {
    favorites: {},
    isSet: false,
}

function FavoritePlantsReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_FAVORITE_PLANT:
        case GET_FAVORITE_PLANTS:
            return {
                ...state,
                isSet: true,
                favorites: action.payload.body || state.favorites,
            }
        case RESET_USER:
            return INITIAL_STATE
        default: return state
    }
}

export default FavoritePlantsReducer



// WEBPACK FOOTER //
// ./src/reducers/favoritePlants.js